import { getValueFromToken } from './getValueFromToken';

export const hasBookAccess = () => {
  return getValueFromToken('hasBookAccess');
};
